export enum TypeReponse {
    'CHECKBOX',
    'RADIO',
    'NONE',
    'INPUT',
    'YESNO',
    'TEXTAREA',
    'LIST',
    'LISTCHOIX',
    'CASPARTICULIER'

}


export class CasParticulierEI {
    public static EI_QUESTION_COURS_CODE= 'EI_QUESTION_COURS_CODE' ;
    public static EI_QUESTION_COURS_LIBELLE = 'EI_QUESTION_COURS_LIBELLE';
    public static EI_QUESTION_COURS_ECTS= 'EI_QUESTION_COURS_ECTS';
}

export class Question {
    constructor(
        public id?: number,
        public typeReponse?: string,
        public reponseComplement?: string,
        public reponseComplementEn?: string,
        public libelle?: string,
        public aide?: string,
        public descriptif?: string,
        public obligatoire?: boolean,
        public interne?: boolean,
        public externe?: boolean,
        public categorieFormationId?: number,
        public candidatureFormationId?: number,
        public formationId?: number,
        public referentId?: number,
        public max?: number,
        public ordre?: number,
        public reponse?: any,
        public libelleEn?: string,
        public aideEn?: string,
        public descriptifEn?: string,
        //calculé par le back mais pas systématiquement présent
        public ordreCategorie?: number,
        public ordreGlobal?: number
    ) {
    } ;


    public static  getLibelleLangue(question: Question, langue: String): String {
        if (question != null) {
            if (langue && langue === 'en' && question.libelleEn != null) {
                return question.libelleEn;
            } else {
                return question.libelle;
            }
        }
        return '' ;
     }

    public static  getTitreModalAide(question: Question, langue: String): String {
        let titre: String = '';
        if (question != null) {
            if (langue && langue === 'en' && question.libelleEn != null) {
                titre = question.libelleEn;
            } else {
                titre = question.libelle;
            }
        }
        if (titre != null && titre.length > 0) {
            titre = titre.replace('<p>', '').replace('</p>', '');
        }
        return titre;
    }

    public static getAide(question: Question, langue: String): String {
        let aide: String = '';
        if (question != null) {
            if (langue && langue === 'en' && question.aideEn != null) {
                aide = question.aideEn;
            } else {
                aide = question.aide;
            }
        }
         return aide ;
    }

    public static questionAvecBouton(question: Question, langue: String) {
        let buttonQuestion: boolean = false;
        if (question != null) {
            let languageLibelle: String = Question.getLibelleLangue(question, langue);
             if (languageLibelle != null) {
                let splitLibelle: string[] = languageLibelle.split('#|');
                if (splitLibelle.length > 1) {
                    buttonQuestion = true;
                }
            }
        }
        return buttonQuestion;
    }

    public static titreBouton(question: Question, langue: String) {
        let languageLibelle: String = Question.getLibelleLangue(question, langue);
        let buttonTitle: String = 'sans titre';
        if (languageLibelle != null) {
            let splitLibelle: string[] = languageLibelle.split('#|');
            if (splitLibelle.length > 3) {
                buttonTitle = splitLibelle[3];
            }
        }
        return buttonTitle;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/question.model.ts